/* eslint-disable @typescript-eslint/no-explicit-any */
import type { LayerProps } from 'react-map-gl/mapbox';

import type { FeatureCollection } from 'geojson';
import { getColorFromCSSVariable } from '../../../../../Utilities';
import type { DealCard } from '../../../../../utils/buildDealCards/dealCardTypes';
import type { Dot } from '../../../ListContainer/CardsGrid/types';

const getColor = () => getColorFromCSSVariable('--lmn-ds-colors-primary-400') || '#000';

export const layerStyle: LayerProps = {
  id: 'hotels_dots',
  source: 'places_dots',
  type: 'circle',
  paint: {
    'circle-radius': {
      base: 2,
      stops: [
        [12, 1.5],
        [22, 36],
      ],
    },
    'circle-color': getColor(),
    'circle-stroke-color': 'transparent',
    'circle-stroke-width': 6,
  },
};

const getDotsGeoJSON = ({ dots, results }: { dots: Dot[] | null; results: DealCard[] }): FeatureCollection => {
  const points = dots
    ?.filter(
      (dot) =>
        results.filter((result) => result.type !== 'dot' && result.product.accommodation.hotelId === dot.hotelId)
          .length === 0
    )
    .map((dot, i) => ({
      id: `dot_${i}`,
      type: 'Feature',
      properties: dot,
      geometry: {
        type: 'Point',
        coordinates: [dot.lng, dot.lat],
      },
    }));
  return {
    type: 'FeatureCollection',
    features: points as any,
  };
};

export default getDotsGeoJSON;
